import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/Card';
import { cn } from '../../utils/cn';
import { motion } from 'framer-motion';
import { Info } from 'lucide-react';
export interface TopListItem {
  id: string;
  label: string;
  value: number;
  subLabel?: string;
  sku?: string;
}
interface TopListProps {
  title: string;
  items: TopListItem[];
  valueLabel?: string;
  icon?: React.ReactNode;
  className?: string;
  barColor?: string;
  showInfo?: boolean;
}
export function TopList({
  title,
  items,
  valueLabel = 'Orders',
  icon,
  className,
  barColor = 'bg-teal-600',
  showInfo = false
}: TopListProps) {
  const maxValue = Math.max(...items.map(i => i.value));
  return <Card className={cn('h-full', className)} data-id="element-123">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-4" data-id="element-124">
        <div className="flex items-center gap-2" data-id="element-125">
          <CardTitle className="text-base font-semibold" data-id="element-126">{title}</CardTitle>
          {showInfo && <Info className="w-3.5 h-3.5 text-slate-300 cursor-help" data-id="element-127" />}
        </div>
        {icon && <div className="text-slate-400" data-id="element-128">{icon}</div>}
      </CardHeader>
      <CardContent className="space-y-4" data-id="element-129">
        {items.map((item, index) => <div key={item.id} className="space-y-1" data-id="element-130">
            <div className="flex items-center justify-between text-sm" data-id="element-131">
              <div className="flex items-center gap-2 min-w-0" data-id="element-132">
                <span className={cn('flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full text-[10px] font-bold', index < 3 ? 'bg-slate-900 text-white' : 'bg-slate-100 text-slate-600')} data-id="element-133">
                  {index + 1}
                </span>
                <div className="flex flex-col min-w-0" data-id="element-134">
                  <span className="font-medium text-slate-700 truncate" title={item.label} data-id="element-135">
                    {item.label}
                  </span>
                  {item.sku && <code className="text-[10px] text-slate-400 font-mono truncate" data-id="element-136">
                      SKU: {item.sku}
                    </code>}
                </div>
              </div>
              <span className="font-bold text-slate-900 ml-2" data-id="element-137">
                {item.value.toLocaleString()}
              </span>
            </div>
            <div className="relative h-1.5 w-full overflow-hidden rounded-full bg-slate-50 border border-slate-100" data-id="element-138">
              <motion.div initial={{
            width: 0
          }} animate={{
            width: `${item.value / maxValue * 100}%`
          }} transition={{
            duration: 1,
            ease: 'easeOut',
            delay: index * 0.05
          }} className={cn('h-full rounded-full', barColor)} data-id="element-139" />
            </div>
          </div>)}
      </CardContent>
    </Card>;
}